// block icon.
export const TabsBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M211.2 283c-2.5-.7-3.3-1.7-3.8-4.3-2.7-15.8-15.5-27.8-31.7-30.1-15.2-2.1-30.7 6.1-37.8 20.3-.4.9-.8 1.1-1.8.8-13.6-3.4-26 9-22.4 22.4.3 1.2 0 1.6-.9 2.3-9.3 6.5-13.5 15.4-11.8 26.6 2 13.1 12.9 22.3 26.1 22.5 12.6.2 25.2 0 37.8 0s25.2.1 37.8 0c15.1-.2 27.8-11.6 30-26.6 2.2-15.1-7-29.6-21.7-33.9ZM205.2 357.1l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM166.9 357.1l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM128.6 357.1 118 367.7c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8s-7.8-3-10.8 0Z"
			className="st1"
		/>
		<rect
			width={ 146.7 }
			height={ 34.4 }
			x={ 264.5 }
			y={ 266.5 }
			className="st1"
			rx={ 17.2 }
			ry={ 17.2 }
		/>
		<rect
			width={ 146.7 }
			height={ 34.4 }
			x={ 264.5 }
			y={ 328.2 }
			className="st1"
			rx={ 17.2 }
			ry={ 17.2 }
		/>
		<path
			d="M512.5 92c0-8-1.5-15.6-4.3-22.7-7.3-26.4-31.5-45.8-60.2-45.8H64c-34.5 0-62.5 28-62.5 62.5v340c0 34.5 28 62.5 62.5 62.5h384c34.5 0 62.5-28 62.5-62.5V190.2h2V92ZM261.1 74.5H450c6.6 0 12.3 3.7 15.3 9 .1.8.2 1.6.2 2.5v59.2H278.6c-9.6 0-17.5-7.9-17.5-17.5V74.5ZM465.5 426c0 9.6-7.9 17.5-17.5 17.5H64c-9.6 0-17.5-7.9-17.5-17.5V86c0-9.6 7.9-17.5 17.5-17.5h152.1v59.2c0 34.5 28 62.5 62.5 62.5h186.9V426Z"
			className="st1"
		/>
	</svg>
);
// preview image.
export const TabsPreview = () => (
	<svg viewBox="0 0 236 158" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			fill="white"
		/>
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			stroke="#9EA9B2"
			strokeWidth={ 1.5 }
		/>
		<path
			d="M20.7322 24.7322C20 25.4645 20 26.643 20 29V129C20 131.357 20 132.536 20.7322 133.268C21.4645 134 22.643 134 25 134H210C212.357 134 213.536 134 214.268 133.268C215 132.536 215 131.357 215 129V40.7188C215 38.3617 215 37.1832 214.268 36.451C213.536 35.7188 212.357 35.7188 210 35.7188H65V24H25C22.643 24 21.4645 24 20.7322 24.7322Z"
			fill="white"
		/>
		<path
			d="M210 133V134H25L25 133H210ZM20 129V29C20 26.7902 20.0001 25.6164 20.6035 24.875L20.7322 24.7322C21.4645 24 22.643 24 25 24H65V35.7188H210C212.357 35.7188 213.536 35.7188 214.268 36.451C215 37.1832 215 38.3617 215 40.7188V129C215 131.357 215 132.536 214.268 133.268C213.536 134 212.357 134 210 134V133C211.207 133 212.012 132.997 212.61 132.917C213.18 132.84 213.411 132.71 213.561 132.561C213.71 132.411 213.84 132.18 213.917 131.61C213.997 131.012 214 130.207 214 129V40.7188C214 39.512 213.997 38.7071 213.917 38.1084C213.84 37.5388 213.71 37.3075 213.561 37.1582C213.411 37.0089 213.18 36.8784 212.61 36.8018C212.012 36.7213 211.207 36.7188 210 36.7188H64V25H25C23.7932 25 22.9883 25.0025 22.3896 25.083C21.8201 25.1596 21.5888 25.2901 21.4395 25.4395C21.2901 25.5888 21.1596 25.8201 21.083 26.3896C21.0025 26.9883 21 27.7932 21 29V129C21 130.207 21.0025 131.012 21.083 131.61C21.1596 132.18 21.2901 132.411 21.4395 132.561C21.5888 132.71 21.8201 132.84 22.3896 132.917C22.9883 132.997 23.7932 133 25 133L25 134L24.1699 133.999C22.4849 133.99 21.5176 133.919 20.875 133.396L20.7322 133.268C20 132.536 20 131.357 20 129Z"
			fill="#58707F"
		/>
		<path d="M65.3125 24H105.312V35.875H65.3125V24Z" fill="#58707F" />
		<path d="M63.75 24H65.3125V42.75H63.75V24Z" fill="white" />
		<path d="M20.9375 25H63.75V26.5625H20.9375V25Z" fill="#58707F" />
		<path d="M107.188 24H147.188V35.875H107.188V24Z" fill="#58707F" />
		<path
			d="M149.062 24H184.062C186.42 24 187.598 24 188.33 24.7322C189.062 25.4645 189.062 26.643 189.062 29V35.875H149.062V24Z"
			fill="#58707F"
		/>
		<path
			d="M30 32.75C30 32.0596 30.5596 31.5 31.25 31.5H53.75C54.4404 31.5 55 32.0596 55 32.75C55 33.4404 54.4404 34 53.75 34H31.25C30.5596 34 30 33.4404 30 32.75Z"
			fill="#58707F"
		/>
		<path
			d="M72.8125 29.9375C72.8125 29.2471 73.3721 28.6875 74.0625 28.6875H96.5625C97.2529 28.6875 97.8125 29.2471 97.8125 29.9375C97.8125 30.6279 97.2529 31.1875 96.5625 31.1875H74.0625C73.3721 31.1875 72.8125 30.6279 72.8125 29.9375Z"
			fill="white"
		/>
		<path
			d="M114.688 29.9375C114.688 29.2471 115.247 28.6875 115.938 28.6875H138.438C139.128 28.6875 139.688 29.2471 139.688 29.9375C139.688 30.6279 139.128 31.1875 138.438 31.1875H115.938C115.247 31.1875 114.688 30.6279 114.688 29.9375Z"
			fill="white"
		/>
		<path
			d="M156.562 29.9375C156.562 29.2471 157.122 28.6875 157.812 28.6875H180.312C181.003 28.6875 181.562 29.2471 181.562 29.9375C181.562 30.6279 181.003 31.1875 180.312 31.1875H157.812C157.122 31.1875 156.562 30.6279 156.562 29.9375Z"
			fill="white"
		/>
		<path
			d="M205 125.25V126.5H30V125.25H205ZM206.25 124V92.75C206.25 92.1254 206.248 91.7827 206.216 91.5449C206.215 91.5416 206.214 91.5384 206.214 91.5352C206.211 91.5348 206.208 91.5346 206.205 91.5342C205.967 91.5022 205.625 91.5 205 91.5H30C29.3754 91.5 29.0327 91.5022 28.7949 91.5342C28.7916 91.5346 28.7883 91.5347 28.7852 91.5352C28.7847 91.5383 28.7846 91.5416 28.7842 91.5449C28.7522 91.7827 28.75 92.1254 28.75 92.75V124C28.75 124.625 28.7522 124.967 28.7842 125.205C28.7846 125.208 28.7848 125.211 28.7852 125.214C28.7884 125.214 28.7916 125.215 28.7949 125.216C29.0327 125.248 29.3754 125.25 30 125.25V126.5C28.8951 126.5 28.3082 126.5 27.9375 126.198L27.8662 126.134C27.5001 125.768 27.5 125.179 27.5 124V92.75C27.5 91.5715 27.5001 90.9823 27.8662 90.6162C28.2323 90.2501 28.8215 90.25 30 90.25H205L205.779 90.2559C206.459 90.273 206.859 90.3416 207.134 90.6162C207.5 90.9823 207.5 91.5715 207.5 92.75V124C207.5 125.179 207.5 125.768 207.134 126.134C206.859 126.408 206.459 126.477 205.779 126.494L205 126.5V125.25C205.625 125.25 205.967 125.248 206.205 125.216C206.208 125.215 206.211 125.214 206.214 125.214C206.214 125.211 206.215 125.208 206.216 125.205C206.248 124.967 206.25 124.625 206.25 124Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.5 107.75H207.5V109H27.5V107.75Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.5 116.5H207.5V117.75H27.5V116.5Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.5 99H207.5V100.25H27.5V99Z"
			fill="#58707F"
		/>
		<path d="M116.25 90.25H117.5V126.188H116.25V90.25Z" fill="#58707F" />
		<path
			d="M32.5 104C32.5 103.31 33.0596 102.75 33.75 102.75C34.4404 102.75 35 103.31 35 104C35 104.69 34.4404 105.25 33.75 105.25C33.0596 105.25 32.5 104.69 32.5 104Z"
			fill="#58707F"
		/>
		<path
			d="M36.25 104C36.25 103.482 36.6697 103.062 37.1875 103.062H45.3125C45.8303 103.062 46.25 103.482 46.25 104C46.25 104.518 45.8303 104.938 45.3125 104.938H37.1875C36.6697 104.938 36.25 104.518 36.25 104Z"
			fill="#58707F"
		/>
		<path
			d="M96.25 104C96.25 103.482 96.6697 103.062 97.1875 103.062H110.312C110.83 103.062 111.25 103.482 111.25 104C111.25 104.518 110.83 104.938 110.312 104.938H97.1875C96.6697 104.938 96.25 104.518 96.25 104Z"
			fill="#58707F"
		/>
		<path
			d="M32.5 95.25C32.5 94.5596 33.0596 94 33.75 94C34.4404 94 35 94.5596 35 95.25C35 95.9404 34.4404 96.5 33.75 96.5C33.0596 96.5 32.5 95.9404 32.5 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M36.25 95.25C36.25 94.7322 36.6697 94.3125 37.1875 94.3125H45.3125C45.8303 94.3125 46.25 94.7322 46.25 95.25C46.25 95.7678 45.8303 96.1875 45.3125 96.1875H37.1875C36.6697 96.1875 36.25 95.7678 36.25 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M101.25 95.25C101.25 94.7322 101.67 94.3125 102.188 94.3125H110.312C110.83 94.3125 111.25 94.7322 111.25 95.25C111.25 95.7678 110.83 96.1875 110.312 96.1875H102.188C101.67 96.1875 101.25 95.7678 101.25 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M32.5 112.75C32.5 112.06 33.0596 111.5 33.75 111.5C34.4404 111.5 35 112.06 35 112.75C35 113.44 34.4404 114 33.75 114C33.0596 114 32.5 113.44 32.5 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M36.25 112.75C36.25 112.232 36.6697 111.812 37.1875 111.812H47.8125C48.3303 111.812 48.75 112.232 48.75 112.75C48.75 113.268 48.3303 113.688 47.8125 113.688H37.1875C36.6697 113.688 36.25 113.268 36.25 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M101.25 112.75C101.25 112.232 101.67 111.812 102.188 111.812H110.312C110.83 111.812 111.25 112.232 111.25 112.75C111.25 113.268 110.83 113.688 110.312 113.688H102.188C101.67 113.688 101.25 113.268 101.25 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M32.5 121.5C32.5 120.81 33.0596 120.25 33.75 120.25C34.4404 120.25 35 120.81 35 121.5C35 122.19 34.4404 122.75 33.75 122.75C33.0596 122.75 32.5 122.19 32.5 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M36.25 121.5C36.25 120.982 36.6697 120.562 37.1875 120.562H47.8125C48.3303 120.562 48.75 120.982 48.75 121.5C48.75 122.018 48.3303 122.438 47.8125 122.438H37.1875C36.6697 122.438 36.25 122.018 36.25 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M101.25 121.5C101.25 120.982 101.67 120.562 102.188 120.562H110.312C110.83 120.562 111.25 120.982 111.25 121.5C111.25 122.018 110.83 122.438 110.312 122.438H102.188C101.67 122.438 101.25 122.018 101.25 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M121.25 104C121.25 103.31 121.81 102.75 122.5 102.75C123.19 102.75 123.75 103.31 123.75 104C123.75 104.69 123.19 105.25 122.5 105.25C121.81 105.25 121.25 104.69 121.25 104Z"
			fill="#58707F"
		/>
		<path
			d="M125 104C125 103.482 125.42 103.062 125.938 103.062H137.812C138.33 103.062 138.75 103.482 138.75 104C138.75 104.518 138.33 104.938 137.812 104.938H125.938C125.42 104.938 125 104.518 125 104Z"
			fill="#58707F"
		/>
		<path
			d="M192.5 104C192.5 103.482 192.92 103.062 193.438 103.062H199.062C199.58 103.062 200 103.482 200 104C200 104.518 199.58 104.938 199.062 104.938H193.438C192.92 104.938 192.5 104.518 192.5 104Z"
			fill="#58707F"
		/>
		<path
			d="M121.25 95.25C121.25 94.5596 121.81 94 122.5 94C123.19 94 123.75 94.5596 123.75 95.25C123.75 95.9404 123.19 96.5 122.5 96.5C121.81 96.5 121.25 95.9404 121.25 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M125 95.25C125 94.7322 125.42 94.3125 125.938 94.3125H135.312C135.83 94.3125 136.25 94.7322 136.25 95.25C136.25 95.7678 135.83 96.1875 135.312 96.1875H125.938C125.42 96.1875 125 95.7678 125 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M186.25 95.25C186.25 94.7322 186.67 94.3125 187.188 94.3125H199.062C199.58 94.3125 200 94.7322 200 95.25C200 95.7678 199.58 96.1875 199.062 96.1875H187.188C186.67 96.1875 186.25 95.7678 186.25 95.25Z"
			fill="#58707F"
		/>
		<path
			d="M121.25 112.75C121.25 112.06 121.81 111.5 122.5 111.5C123.19 111.5 123.75 112.06 123.75 112.75C123.75 113.44 123.19 114 122.5 114C121.81 114 121.25 113.44 121.25 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M125 112.75C125 112.232 125.42 111.812 125.938 111.812H135.312C135.83 111.812 136.25 112.232 136.25 112.75C136.25 113.268 135.83 113.688 135.312 113.688H125.938C125.42 113.688 125 113.268 125 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M186.25 112.75C186.25 112.232 186.67 111.812 187.188 111.812H199.062C199.58 111.812 200 112.232 200 112.75C200 113.268 199.58 113.688 199.062 113.688H187.188C186.67 113.688 186.25 113.268 186.25 112.75Z"
			fill="#58707F"
		/>
		<path
			d="M121.25 121.5C121.25 120.81 121.81 120.25 122.5 120.25C123.19 120.25 123.75 120.81 123.75 121.5C123.75 122.19 123.19 122.75 122.5 122.75C121.81 122.75 121.25 122.19 121.25 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M125 121.5C125 120.982 125.42 120.562 125.938 120.562H135.312C135.83 120.562 136.25 120.982 136.25 121.5C136.25 122.018 135.83 122.438 135.312 122.438H125.938C125.42 122.438 125 122.018 125 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M186.25 121.5C186.25 120.982 186.67 120.562 187.188 120.562H199.062C199.58 120.562 200 120.982 200 121.5C200 122.018 199.58 122.438 199.062 122.438H187.188C186.67 122.438 186.25 122.018 186.25 121.5Z"
			fill="#58707F"
		/>
		<path
			d="M27.5 45.25C27.5 44.5596 28.0596 44 28.75 44H61.25C61.9404 44 62.5 44.5596 62.5 45.25C62.5 45.9404 61.9404 46.5 61.25 46.5H28.75C28.0596 46.5 27.5 45.9404 27.5 45.25Z"
			fill="#58707F"
		/>
		<path
			d="M27.5 50.25C27.5 49.5596 28.0596 49 28.75 49H38.75C39.4404 49 40 49.5596 40 50.25C40 50.9404 39.4404 51.5 38.75 51.5H28.75C28.0596 51.5 27.5 50.9404 27.5 50.25Z"
			fill="#58707F"
		/>
		<path
			d="M42.5 50.25C42.5 49.5596 43.0596 49 43.75 49H53.75C54.4404 49 55 49.5596 55 50.25C55 50.9404 54.4404 51.5 53.75 51.5H43.75C43.0596 51.5 42.5 50.9404 42.5 50.25Z"
			fill="#58707F"
		/>
		<path
			d="M27.5 77.75C27.5 77.0596 28.0596 76.5 28.75 76.5H38.75C39.4404 76.5 40 77.0596 40 77.75C40 78.4404 39.4404 79 38.75 79H28.75C28.0596 79 27.5 78.4404 27.5 77.75Z"
			fill="#9FABB4"
		/>
		<path
			d="M41.25 77.75C41.25 77.0596 41.8096 76.5 42.5 76.5H52.5C53.1904 76.5 53.75 77.0596 53.75 77.75C53.75 78.4404 53.1904 79 52.5 79H42.5C41.8096 79 41.25 78.4404 41.25 77.75Z"
			fill="#58707F"
		/>
		<path
			d="M27.5 82.75C27.5 82.0596 28.0596 81.5 28.75 81.5H46.25C46.9404 81.5 47.5 82.0596 47.5 82.75C47.5 83.4404 46.9404 84 46.25 84H28.75C28.0596 84 27.5 83.4404 27.5 82.75Z"
			fill="#58707F"
		/>
		<path
			d="M48.75 82.125C48.75 81.7798 49.0298 81.5 49.375 81.5C49.7202 81.5 50 81.7798 50 82.125V83.375C50 83.7202 49.7202 84 49.375 84C49.0298 84 48.75 83.7202 48.75 83.375V82.125Z"
			fill="#58707F"
		/>
		<path
			d="M51.25 82.75C51.25 82.0596 51.8096 81.5 52.5 81.5H60C60.6904 81.5 61.25 82.0596 61.25 82.75C61.25 83.4404 60.6904 84 60 84H52.5C51.8096 84 51.25 83.4404 51.25 82.75Z"
			fill="#58707F"
		/>
		<path
			d="M50.1536 62.7333H51.4968C51.7271 62.7577 51.9592 62.7211 52.1763 62.6261C52.3933 62.5312 52.5899 62.3801 52.7519 62.184C53.0349 61.7524 53.1758 61.213 53.1482 60.6669C53.1663 60.1543 53.0253 59.6516 52.7519 59.2544C52.5962 59.072 52.4097 58.9311 52.2047 58.8409C51.9997 58.7507 51.7809 58.7133 51.5628 58.7313C51.1526 58.7193 50.7529 58.8869 50.4398 59.2021C50.2966 59.3631 50.1833 59.5581 50.1075 59.7743C50.0316 59.9906 49.9948 60.2234 49.9995 60.4576H47.6874C47.6639 59.9186 47.7497 59.3807 47.9374 58.8891C48.1252 58.3976 48.4094 57.9667 48.7664 57.6327C49.539 56.8743 50.5169 56.4747 51.5188 56.5079C52.5818 56.4384 53.6299 56.8287 54.4694 57.6065C54.8229 57.9872 55.0996 58.4577 55.2788 58.9831C55.458 59.5084 55.5351 60.0751 55.5043 60.6407C55.5031 61.2872 55.3339 61.9176 55.0198 62.4456C54.6846 63.0293 54.2197 63.4911 53.6767 63.7796C54.2852 64.0177 54.8111 64.4863 55.174 65.1136C55.5288 65.7191 55.7138 66.4423 55.7024 67.18C55.7284 67.7816 55.6342 68.3819 55.4276 68.932C55.2209 69.482 54.9077 69.9662 54.5134 70.345C53.6448 71.1385 52.5697 71.5457 51.4747 71.4959C50.4592 71.5354 49.4635 71.1565 48.6563 70.4235C48.2625 70.0707 47.9508 69.6046 47.7505 69.0692C47.5502 68.5338 47.4679 67.9467 47.5113 67.3631H49.7132C49.7055 67.6219 49.7448 67.8797 49.8283 68.1189C49.9119 68.3581 50.0379 68.5732 50.1976 68.7494C50.5322 69.1174 50.975 69.3147 51.4307 69.2987C51.6692 69.317 51.9082 69.2751 52.132 69.176C52.3559 69.0768 52.5597 68.9225 52.7298 68.7233C52.897 68.5261 53.0267 68.2887 53.1103 68.027C53.1938 67.7653 53.2293 67.4854 53.2143 67.2062C53.2552 66.9055 53.2358 66.5976 53.1577 66.3074C53.0796 66.0173 52.9449 65.7532 52.7647 65.5366C52.5845 65.3199 52.3637 65.1568 52.1205 65.0606C51.8772 64.9644 51.6182 64.9377 51.3646 64.9828H50.0215L50.1536 62.7333Z"
			fill="#58707F"
		/>
		<path
			d="M65.413 71.2866H57.3319V69.3771L61.1633 64.3027C61.6151 63.6894 62.0135 63.0234 62.3523 62.3147C62.5647 61.8565 62.6853 61.3463 62.7046 60.8238C62.7182 60.2756 62.5702 59.739 62.2862 59.3067C62.1474 59.1099 61.9711 58.9551 61.7721 58.8551C61.573 58.7551 61.3568 58.7126 61.1412 58.7312C60.9008 58.7098 60.6596 58.7609 60.4402 58.8798C60.2208 58.9986 60.0302 59.1815 59.8862 59.4113C59.5949 59.9578 59.4491 60.5959 59.4678 61.2423H57.1558C57.1312 60.6282 57.2123 60.0146 57.394 59.4389C57.5757 58.8633 57.8543 58.3377 58.2127 57.8942C58.5943 57.4289 59.0545 57.0648 59.5631 56.8258C60.0716 56.5869 60.617 56.4785 61.1633 56.5078C62.2175 56.4361 63.2532 56.8587 64.0478 57.6849C64.3986 58.0903 64.6724 58.5801 64.8509 59.1214C65.0293 59.6628 65.1084 60.2432 65.0827 60.8238C65.0964 61.6837 64.8973 62.5295 64.5102 63.2564C63.9191 64.2976 63.2641 65.2855 62.5505 66.2121L60.3486 69.0371H65.413V71.2866Z"
			fill="#58707F"
		/>
		<path
			d="M68.579 58.2682C68.5666 57.9751 68.645 57.6867 68.7991 57.4574C68.8797 57.3527 68.9787 57.2703 69.089 57.216C69.1994 57.1618 69.3184 57.137 69.4377 57.1435C69.5605 57.1349 69.6833 57.1586 69.7975 57.2129C69.9116 57.2671 70.0144 57.3506 70.0983 57.4574C70.2525 57.6867 70.3308 57.9751 70.3185 58.2682C70.3329 58.5617 70.2543 58.851 70.0983 59.0791C70.0177 59.1838 69.9188 59.2662 69.8084 59.3205C69.6981 59.3747 69.579 59.3995 69.4597 59.393C69.337 59.4016 69.2141 59.3779 69.1 59.3236C68.9858 59.2694 68.8831 59.1859 68.7991 59.0791C68.6431 58.851 68.5645 58.5617 68.579 58.2682ZM69.0634 58.2682C69.0333 58.4231 69.0333 58.5842 69.0634 58.7391C69.0956 58.8004 69.1414 58.8499 69.1958 58.8822C69.2502 58.9145 69.3111 58.9283 69.3716 58.9222C69.4262 58.928 69.481 58.9135 69.5283 58.8807C69.5757 58.8479 69.6133 58.7984 69.6359 58.7391C69.7138 58.6001 69.7524 58.4351 69.746 58.2682C69.7486 58.1333 69.726 57.9993 69.6799 57.8759C69.6535 57.8145 69.6119 57.7641 69.5608 57.7314C69.5097 57.6987 69.4514 57.6852 69.3937 57.6928C69.3391 57.687 69.2843 57.7015 69.237 57.7343C69.1896 57.7671 69.1521 57.8166 69.1294 57.8759C69.0575 58.0181 69.0195 58.1808 69.0193 58.3467L69.0634 58.2682Z"
			fill="#58707F"
		/>
		<path
			d="M74.0837 60.5436C74.0946 60.7842 74.0631 61.0249 73.991 61.2502C73.919 61.4754 73.808 61.6802 73.6653 61.8515C73.3242 62.1802 72.893 62.3479 72.4543 62.3223C72.2205 62.3401 71.9863 62.2953 71.7691 62.1912C71.5518 62.0871 71.3571 61.9263 71.1992 61.7207C71.0354 61.5206 70.9079 61.2828 70.8245 61.0218C70.7412 60.7609 70.7038 60.4824 70.7147 60.2036V59.2096C70.6944 58.6513 70.8606 58.106 71.1771 57.6925C71.5184 57.3375 71.9566 57.1418 72.4102 57.1418C72.8638 57.1418 73.302 57.3375 73.6433 57.6925C73.7948 57.8571 73.913 58.0602 73.9893 58.2867C74.0655 58.5131 74.0978 58.7571 74.0837 59.0004H73.247C73.2621 58.719 73.1918 58.4406 73.0488 58.2157C72.9635 58.1217 72.8627 58.05 72.7527 58.0049C72.6428 57.9599 72.5261 57.9426 72.4102 57.9541C72.3017 57.9736 72.1981 58.0211 72.1068 58.0935C72.0155 58.1658 71.9386 58.2611 71.8818 58.3726C71.7242 58.6595 71.6471 58.9983 71.6616 59.3404V60.3344C71.6432 60.6809 71.729 61.0239 71.9038 61.3022C71.979 61.4179 72.0758 61.5113 72.1867 61.5748C72.2975 61.6384 72.4193 61.6704 72.5423 61.6684C72.6516 61.681 72.7619 61.664 72.8649 61.6187C72.9678 61.5734 73.0608 61.5009 73.1369 61.4068C73.2843 61.1947 73.3555 60.9222 73.335 60.6483L74.0837 60.5436Z"
			fill="#58707F"
		/>
		<path
			d="M79.2748 58.2682C79.2624 57.9751 79.3408 57.6867 79.4949 57.4574C79.5755 57.3527 79.6745 57.2703 79.7848 57.216C79.8952 57.1618 80.0142 57.137 80.1335 57.1435C80.2563 57.1349 80.3791 57.1586 80.4933 57.2129C80.6074 57.2671 80.7102 57.3506 80.7941 57.4574C80.9483 57.6867 81.0266 57.9751 81.0143 58.2682C81.0287 58.5617 80.9501 58.851 80.7941 59.0791C80.7135 59.1838 80.6146 59.2662 80.5042 59.3205C80.3939 59.3747 80.2748 59.3995 80.1555 59.393C80.0328 59.4016 79.9099 59.3779 79.7958 59.3236C79.6816 59.2694 79.5789 59.1859 79.4949 59.0791C79.3389 58.851 79.2603 58.5617 79.2748 58.2682ZM79.7592 58.2682C79.7291 58.4231 79.7291 58.5842 79.7592 58.7391C79.7914 58.8004 79.8372 58.8499 79.8916 58.8822C79.946 58.9145 80.0069 58.9283 80.0674 58.9222C80.122 58.928 80.1768 58.9135 80.2241 58.8807C80.2715 58.8479 80.3091 58.7984 80.3317 58.7391C80.4096 58.6001 80.4482 58.4351 80.4418 58.2682C80.4444 58.1333 80.4218 57.9993 80.3757 57.8759C80.3493 57.8145 80.3077 57.7641 80.2566 57.7314C80.2055 57.6987 80.1472 57.6852 80.0895 57.6928C80.0349 57.687 79.9801 57.7015 79.9328 57.7343C79.8854 57.7671 79.8479 57.8166 79.8252 57.8759C79.7533 58.0181 79.7153 58.1808 79.7151 58.3467L79.7592 58.2682Z"
			fill="#58707F"
		/>
		<path
			d="M84.229 60.2022H82.5327V62.3732H81.6846V57.1418H84.6107V57.9527H82.5327V59.3913H84.3138L84.229 60.2022Z"
			fill="#58707F"
		/>
		<path
			d="M76.5991 57.476C76.5991 57.2914 76.7488 57.1418 76.9334 57.1418C77.118 57.1418 77.2676 57.2914 77.2676 57.476V62.1553C77.2676 62.3399 77.118 62.4895 76.9334 62.4895C76.7488 62.4895 76.5991 62.3399 76.5991 62.1553V57.476Z"
			fill="#58707F"
		/>
		<path
			d="M44.4031 67.8875C44.4023 68.9012 43.9995 69.8731 43.283 70.5902C42.5666 71.3072 41.5949 71.7106 40.5813 71.7122H30.7736C29.6303 71.6832 28.5436 71.2087 27.7452 70.3898C26.9468 69.571 26.5 68.4726 26.5 67.3288C26.5 66.1852 26.9468 65.0868 27.7452 64.2678C28.5436 63.449 29.6303 62.9745 30.7736 62.9455H30.8946C31.098 62.1302 31.5428 61.3955 32.1709 60.8374C32.7989 60.2793 33.5809 59.9239 34.4144 59.8178C35.2477 59.7116 36.0939 59.8597 36.8417 60.2425C37.5896 60.6253 38.2044 61.2251 38.6056 61.9633C38.8132 61.9149 39.0257 61.8904 39.2389 61.8901C39.9168 61.8936 40.5702 62.1446 41.076 62.5961C41.5818 63.0474 41.9053 63.6681 41.9856 64.3414C42.6963 64.6238 43.3063 65.1123 43.7371 65.7443C44.1679 66.3762 44.3999 67.1228 44.4031 67.8875Z"
			fill="#58707F"
		/>
		<path
			d="M169.375 50.5625C176.247 50.5625 182.954 52.6586 188.589 56.5684C194.224 60.4781 198.515 66.0135 200.88 72.4258C201.059 72.9115 200.81 73.4507 200.324 73.6299C199.839 73.8089 199.299 73.5599 199.12 73.0742C196.888 67.0245 192.839 61.8007 187.52 58.1094C182.2 54.418 175.866 52.4375 169.375 52.4375C162.884 52.4375 156.55 54.418 151.23 58.1094C145.911 61.8007 141.862 67.0245 139.63 73.0742C139.451 73.5599 138.911 73.8089 138.426 73.6299C137.94 73.4507 137.691 72.9115 137.87 72.4258C140.235 66.0135 144.526 60.4781 150.161 56.5684C155.796 52.6586 162.503 50.5625 169.375 50.5625Z"
			fill="#58707F"
		/>
		<path
			d="M133.75 77.75C133.75 77.0596 134.31 76.5 135 76.5H142.5C143.19 76.5 143.75 77.0596 143.75 77.75C143.75 78.4404 143.19 79 142.5 79H135C134.31 79 133.75 78.4404 133.75 77.75Z"
			fill="#9FABB4"
		/>
		<path
			d="M131.25 81.5C131.25 80.8096 131.81 80.25 132.5 80.25H145C145.69 80.25 146.25 80.8096 146.25 81.5C146.25 82.1904 145.69 82.75 145 82.75H132.5C131.81 82.75 131.25 82.1904 131.25 81.5Z"
			fill="#58707F"
		/>
		<path
			d="M194.375 77.75C194.375 77.0596 194.935 76.5 195.625 76.5H204.375C205.065 76.5 205.625 77.0596 205.625 77.75C205.625 78.4404 205.065 79 204.375 79H195.625C194.935 79 194.375 78.4404 194.375 77.75Z"
			fill="#9FABB4"
		/>
		<path
			d="M192.5 81.5C192.5 80.8096 193.06 80.25 193.75 80.25H206.25C206.94 80.25 207.5 80.8096 207.5 81.5C207.5 82.1904 206.94 82.75 206.25 82.75H193.75C193.06 82.75 192.5 82.1904 192.5 81.5Z"
			fill="#58707F"
		/>
		<path
			d="M164.259 49.0694C164.37 49.1813 164.517 49.2372 164.664 49.2372C164.81 49.2372 164.957 49.1813 165.069 49.0694C165.293 48.8456 165.293 48.483 165.069 48.2592L164.259 47.4491C164.035 47.2253 163.672 47.2253 163.448 47.4491C163.225 47.6729 163.225 48.0354 163.448 48.2592L164.259 49.0694Z"
			fill="#58707F"
		/>
		<path
			d="M164.062 51.5002C164.062 51.1838 163.806 50.9794 163.489 50.9794H162.344C162.027 50.9794 161.771 51.1838 161.771 51.5002C161.771 51.8166 162.027 52.021 162.344 52.021H163.489C163.806 52.021 164.062 51.8166 164.062 51.5002Z"
			fill="#58707F"
		/>
		<path
			d="M167.5 48.0626C167.816 48.0626 168.02 47.8061 168.02 47.4897V46.3439C168.02 46.0274 167.816 45.7709 167.5 45.7709C167.183 45.7709 166.979 46.0274 166.979 46.3439V47.4897C166.979 47.8061 167.183 48.0626 167.5 48.0626Z"
			fill="#58707F"
		/>
		<path
			d="M170.336 49.2372C170.483 49.2372 170.629 49.1813 170.741 49.0694L171.551 48.2592C171.775 48.0354 171.775 47.6729 171.551 47.4491C171.328 47.2253 170.965 47.2253 170.741 47.4491L169.931 48.2592C169.707 48.483 169.707 48.8456 169.931 49.0694C170.043 49.1813 170.189 49.2372 170.336 49.2372Z"
			fill="#58707F"
		/>
		<path
			d="M167.5 48.6356C165.92 48.6356 164.635 49.9208 164.635 51.5002C164.635 53.0796 165.92 54.3648 167.5 54.3648C169.079 54.3648 170.364 53.0796 170.364 51.5002C170.364 49.9208 169.079 48.6356 167.5 48.6356Z"
			fill="#58707F"
		/>
		<path
			d="M164.259 53.9307L163.448 54.7409C163.225 54.9646 163.225 55.3272 163.448 55.551C163.56 55.6629 163.707 55.7188 163.854 55.7188C164 55.7188 164.147 55.6629 164.259 55.551L165.069 54.7409C165.293 54.5171 165.293 54.1545 165.069 53.9307C164.845 53.7069 164.482 53.7069 164.259 53.9307Z"
			fill="#58707F"
		/>
		<path
			d="M170.741 53.9307C170.517 53.7069 170.155 53.7069 169.931 53.9307C169.707 54.1545 169.707 54.5171 169.931 54.7409L170.741 55.551C170.853 55.6629 171 55.7188 171.146 55.7188C171.293 55.7188 171.439 55.6629 171.551 55.551C171.775 55.3272 171.775 54.9646 171.551 54.7409L170.741 53.9307Z"
			fill="#58707F"
		/>
		<path
			d="M172.656 50.9794H171.51C171.194 50.9794 170.938 51.1838 170.938 51.5002C170.938 51.8166 171.194 52.021 171.51 52.021H172.656C172.973 52.021 173.229 51.8166 173.229 51.5002C173.229 51.1838 172.973 50.9794 172.656 50.9794Z"
			fill="#58707F"
		/>
		<path
			d="M167.5 54.9375C167.183 54.9375 166.979 55.194 166.979 55.5104V56.6562C166.979 56.9727 167.183 57.2292 167.5 57.2292C167.816 57.2292 168.02 56.9727 168.02 56.6562V55.5104C168.02 55.194 167.816 54.9375 167.5 54.9375Z"
			fill="#58707F"
		/>
	</svg>
);
//tabs preset image
export const TabsPresetOne = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<path
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.692 }
			d="M8.303 5.88h21.794v9.687h80.601c.662 0 1.124 0 1.472.047.338.045.518.13.645.257.128.127.212.307.257.645.047.349.047.81.047 1.472v45.663c0 .662 0 1.124-.047 1.473-.045.338-.129.517-.257.644-.127.128-.307.212-.645.257-.348.047-.81.048-1.472.048H8.303c-.662 0-1.125-.001-1.473-.048-.338-.045-.518-.13-.645-.257-.128-.127-.21-.306-.256-.644-.047-.349-.048-.81-.048-1.473V8.302c0-.662 0-1.124.048-1.472.045-.338.128-.518.256-.646.127-.127.307-.21.645-.256.348-.046.81-.047 1.473-.047Z"
		/>
		<path fill="#58707F" d="M31.133 5.535h22.14v9.686h-22.14V5.535Z" />
		<path
			fill="#fff"
			d="M53.273 5.535h1.384v9.686h-1.384V5.535ZM29.75 5.535h1.384v10.378H29.75V5.535Z"
		/>
		<path fill="#58707F" d="M6.227 6.227H29.75V7.61H6.227V6.227Z" />
		<path fill="#fff" d="M76.797 5.535h1.384v9.686h-1.384V5.535Z" />
		<path
			fill="#58707F"
			d="M54.656 5.535h22.14v9.686h-22.14V5.535ZM78.18 5.535h19.372c1.304 0 1.957 0 2.362.405s.405 1.058.405 2.362v6.919h-22.14V5.535Z"
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 11.07 }
			y={ 10.378 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 35.285 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 59.5 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 83.715 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<path
			stroke="#58707F"
			strokeLinecap="round"
			strokeMiterlimit={ 10 }
			strokeWidth={ 1.038 }
			d="M71.262 37.36a17.946 17.946 0 0 1 6.612-8.53A18.138 18.138 0 0 1 88.212 25.6c3.698 0 7.307 1.128 10.34 3.232a17.943 17.943 0 0 1 6.611 8.53"
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 68.494 }
			y={ 39.436 }
			fill="#9FABB4"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 67.111 }
			y={ 41.512 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 102.049 }
			y={ 39.436 }
			fill="#9FABB4"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 101.012 }
			y={ 41.512 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 98.936 }
			height={ 14.529 }
			x={ 10.031 }
			y={ 47.392 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.346 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M9.686 56.733h99.627v.691H9.686v-.691ZM9.686 51.89h99.627v.691H9.686v-.692Z"
			clipRule="evenodd"
		/>
		<path fill="#58707F" d="M58.809 47.047h.692v14.529h-.692z" />
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 12.453 }
			y={ 53.965 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 14.529 }
			y={ 54.138 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.038 }
			x={ 47.738 }
			y={ 54.138 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 12.453 }
			y={ 49.122 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 14.529 }
			y={ 49.295 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 50.506 }
			y={ 49.295 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 12.453 }
			y={ 58.808 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 14.529 }
			y={ 58.981 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 50.506 }
			y={ 58.981 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 61.576 }
			y={ 53.965 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 7.61 }
			height={ 1.038 }
			x={ 63.652 }
			y={ 54.138 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 4.151 }
			height={ 1.038 }
			x={ 101.012 }
			y={ 54.138 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 61.576 }
			y={ 49.122 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 63.652 }
			y={ 49.295 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 7.61 }
			height={ 1.038 }
			x={ 97.553 }
			y={ 49.295 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 61.576 }
			y={ 58.808 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 63.652 }
			y={ 58.981 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 7.61 }
			height={ 1.038 }
			x={ 97.553 }
			y={ 58.981 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 19.372 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 20.064 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 22.831 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 17.988 }
			y={ 22.831 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 38.052 }
			fill="#9FABB4"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 17.297 }
			y={ 38.052 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 40.82 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 0.692 }
			height={ 1.384 }
			x={ 21.447 }
			y={ 40.82 }
			fill="#58707F"
			rx={ 0.346 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 22.83 }
			y={ 40.82 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M22.225 30.433h.743a.74.74 0 0 0 .376-.06.867.867 0 0 0 .319-.244c.156-.24.234-.538.22-.84a1.305 1.305 0 0 0-.22-.782.85.85 0 0 0-.303-.229.731.731 0 0 0-.355-.06.841.841 0 0 0-.622.26.946.946 0 0 0-.184.317 1.08 1.08 0 0 0-.06.378h-1.28a2.177 2.177 0 0 1 .139-.868c.104-.272.261-.51.459-.695.427-.42.969-.642 1.523-.623.588-.038 1.169.178 1.633.608.196.21.35.471.448.762.1.29.142.604.125.917 0 .358-.094.707-.268 1a1.894 1.894 0 0 1-.743.738c.336.131.627.39.828.738.197.335.3.736.293 1.144.014.333-.038.665-.152.97a2.112 2.112 0 0 1-.506.782c-.481.439-1.076.664-1.682.637-.562.021-1.113-.188-1.56-.594a1.894 1.894 0 0 1-.502-.75 2.234 2.234 0 0 1-.132-.944h1.219c-.004.143.017.286.064.419.046.132.115.25.204.349.185.203.43.312.683.303a.803.803 0 0 0 .388-.068.935.935 0 0 0 .33-.25c.093-.11.165-.24.211-.385.046-.145.066-.3.058-.455a1.263 1.263 0 0 0-.032-.497 1.122 1.122 0 0 0-.217-.427.895.895 0 0 0-.357-.263.767.767 0 0 0-.418-.043h-.744l.074-1.245ZM30.67 35.167h-4.473V34.11l2.121-2.809c.25-.34.47-.708.658-1.1.118-.254.184-.536.195-.825.008-.304-.074-.6-.231-.84a.78.78 0 0 0-.285-.25.65.65 0 0 0-.35-.069.683.683 0 0 0-.387.083.836.836 0 0 0-.307.294 2.04 2.04 0 0 0-.231 1.013H26.1c-.014-.34.031-.68.132-.998.1-.318.255-.61.453-.855a2.16 2.16 0 0 1 .747-.591c.282-.132.584-.192.886-.176.584-.04 1.157.194 1.597.651.194.225.345.496.444.795.099.3.143.621.128.943.008.476-.102.944-.316 1.346-.328.576-.69 1.123-1.085 1.636l-1.219 1.564h2.803v1.245ZM32.423 27.961a.752.752 0 0 1 .122-.449.46.46 0 0 1 .16-.133.387.387 0 0 1 .193-.04.398.398 0 0 1 .2.038.47.47 0 0 1 .166.135.752.752 0 0 1 .122.45.736.736 0 0 1-.122.448.46.46 0 0 1-.16.134.387.387 0 0 1-.194.04.399.399 0 0 1-.199-.039.468.468 0 0 1-.166-.135.736.736 0 0 1-.122-.449Zm.268 0a.688.688 0 0 0 0 .26.2.2 0 0 0 .073.08c.03.018.064.026.098.022.03.003.06-.005.086-.023a.166.166 0 0 0 .06-.078.497.497 0 0 0 .06-.26.589.589 0 0 0-.036-.218.178.178 0 0 0-.066-.08.138.138 0 0 0-.092-.021.128.128 0 0 0-.087.023.167.167 0 0 0-.06.078.58.58 0 0 0-.06.26l.024-.043ZM35.47 29.22c.005.134-.012.267-.052.392a.99.99 0 0 1-.18.333.89.89 0 0 1-.67.26.743.743 0 0 1-.38-.072.881.881 0 0 1-.315-.26 1.172 1.172 0 0 1-.208-.388 1.324 1.324 0 0 1-.06-.453v-.55c-.012-.309.08-.61.256-.84a.947.947 0 0 1 .682-.304c.251 0 .494.108.682.305.084.09.15.203.192.328.042.126.06.26.052.395h-.463a.74.74 0 0 0-.11-.434.456.456 0 0 0-.163-.116.395.395 0 0 0-.19-.029.378.378 0 0 0-.168.078.467.467 0 0 0-.124.154c-.088.159-.13.346-.122.536v.55a.92.92 0 0 0 .134.535.463.463 0 0 0 .156.151.382.382 0 0 0 .197.052.343.343 0 0 0 .179-.027.404.404 0 0 0 .15-.118.655.655 0 0 0 .11-.42l.414-.057ZM38.343 27.961a.753.753 0 0 1 .122-.449.46.46 0 0 1 .16-.133.387.387 0 0 1 .193-.04.399.399 0 0 1 .2.038.47.47 0 0 1 .166.135.753.753 0 0 1 .122.45.736.736 0 0 1-.122.448.46.46 0 0 1-.16.134.387.387 0 0 1-.194.04.399.399 0 0 1-.199-.039.47.47 0 0 1-.166-.135.736.736 0 0 1-.122-.449Zm.268 0a.684.684 0 0 0 0 .26.198.198 0 0 0 .073.08c.03.018.064.026.098.022.03.003.06-.005.086-.023a.166.166 0 0 0 .06-.078.497.497 0 0 0 .06-.26.591.591 0 0 0-.036-.218.177.177 0 0 0-.066-.08.138.138 0 0 0-.092-.021.128.128 0 0 0-.087.023.167.167 0 0 0-.06.078.58.58 0 0 0-.06.26l.024-.043ZM41.084 29.032h-.939v1.201h-.47v-2.895h1.62v.449h-1.15v.796h.986l-.047.449Z"
		/>
		<rect
			width={ 0.37 }
			height={ 2.96 }
			x={ 36.861 }
			y={ 27.338 }
			fill="#58707F"
			rx={ 0.185 }
		/>
		<path
			fill="#58707F"
			d="M19.595 33.147a2.119 2.119 0 0 1-2.116 2.117h-5.428a2.427 2.427 0 0 1 0-4.852h.067a2.309 2.309 0 0 1 4.268-.544 1.54 1.54 0 0 1 1.87 1.316 2.123 2.123 0 0 1 1.339 1.963Z"
		/>
		<g fill="#58707F" clipPath="url(#a)">
			<path d="M85.381 24.253a.316.316 0 1 0 .448-.448l-.448-.448a.317.317 0 1 0-.448.448l.448.448ZM85.272 25.599c0-.175-.142-.288-.317-.288h-.634c-.175 0-.317.113-.317.288s.142.288.317.288h.634c.175 0 .317-.113.317-.288ZM87.173 23.696c.175 0 .288-.142.288-.317v-.634c0-.175-.113-.317-.288-.317s-.288.142-.288.317v.634c0 .175.113.317.288.317ZM88.745 24.346a.316.316 0 0 0 .224-.093l.448-.448a.317.317 0 1 0-.448-.448l-.448.448a.317.317 0 0 0 .224.541ZM87.173 24.013c-.874 0-1.585.712-1.585 1.586 0 .874.711 1.585 1.585 1.585.875 0 1.586-.711 1.586-1.585s-.711-1.586-1.586-1.586ZM85.381 26.944l-.448.449a.317.317 0 0 0 .448.448l.449-.448a.317.317 0 0 0-.449-.449ZM88.969 26.944a.317.317 0 0 0-.448.449l.448.448a.316.316 0 0 0 .448 0 .317.317 0 0 0 0-.448l-.448-.449ZM90.028 25.31h-.635c-.175 0-.317.114-.317.289s.142.288.317.288h.635c.175 0 .317-.113.317-.288s-.142-.288-.317-.288ZM87.173 27.502c-.175 0-.288.141-.288.317v.634c0 .175.113.317.288.317s.288-.142.288-.317v-.634c0-.176-.113-.317-.288-.317Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M83.715 22.14h6.919v6.919h-6.92z" />
			</clipPath>
		</defs>
	</svg>
);
export const TabsPresetTwo = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<path
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.692 }
			d="M8.303 5.88h21.794v9.687h80.601c.662 0 1.124 0 1.472.047.338.045.518.13.645.257.128.127.212.307.257.645.047.349.047.81.047 1.472v45.663c0 .662 0 1.124-.047 1.473-.045.338-.129.517-.257.644-.127.128-.307.212-.645.257-.348.047-.81.048-1.472.048H8.303c-.662 0-1.125-.001-1.473-.048-.338-.045-.518-.13-.645-.257-.128-.127-.21-.306-.256-.644-.047-.349-.048-.81-.048-1.473V8.302c0-.662 0-1.124.048-1.472.045-.338.128-.518.256-.646.127-.127.307-.21.645-.256.348-.046.81-.047 1.473-.047Z"
		/>
		<path fill="#58707F" d="M31.133 5.535h22.14v9.686h-22.14V5.535Z" />
		<path
			fill="#fff"
			d="M53.273 5.535h1.384v9.686h-1.384V5.535ZM29.75 5.535h1.384v10.378H29.75V5.535Z"
		/>
		<path fill="#58707F" d="M6.227 6.227H29.75V7.61H6.227V6.227Z" />
		<path fill="#fff" d="M76.797 5.535h1.384v9.686h-1.384V5.535Z" />
		<path
			fill="#58707F"
			d="M54.656 5.535h22.14v9.686h-22.14V5.535ZM78.18 5.535h19.372c1.304 0 1.957 0 2.362.405s.405 1.058.405 2.362v6.919h-22.14V5.535Z"
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 11.07 }
			y={ 10.378 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 35.285 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 58.809 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 82.332 }
			y={ 9.686 }
			fill="#fff"
			rx={ 1.038 }
		/>
		<rect
			width={ 62.267 }
			height={ 38.744 }
			x={ 45.317 }
			y={ 21.794 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.346 }
		/>
		<path fill="#58707F" d="M76.106 21.448h.692v39.436h-.692z" />
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 40.82h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 38.052 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 38.225 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 38.225 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 38.052 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 38.225 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 38.225 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 35.977h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 33.209 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 33.382 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 33.382 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 33.209 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 33.382 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 33.382 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 31.134h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 28.366 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 28.539 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 28.539 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 28.366 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 28.539 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 28.539 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 26.29h62.96v.693H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 23.523 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 23.696 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 23.696 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 23.523 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 23.696 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 23.696 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 45.663h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 42.895 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 43.068 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 43.068 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 42.895 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 43.068 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 43.068 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 50.506h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 47.738 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 47.911 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 47.911 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 47.738 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 47.911 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 47.911 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M44.97 55.349h62.96v.692H44.97v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 52.581 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 52.754 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 52.754 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 52.581 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 52.754 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 52.754 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 47.047 }
			y={ 57.424 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 49.123 }
			y={ 57.597 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 69.186 }
			y={ 57.597 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 1.384 }
			height={ 1.384 }
			x={ 78.18 }
			y={ 57.424 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.038 }
			x={ 80.256 }
			y={ 57.597 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.038 }
			x={ 100.318 }
			y={ 57.597 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 22.14 }
			height={ 2.076 }
			x={ 14.859 }
			y={ 28.366 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 18.318 }
			y={ 31.826 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 26.621 }
			y={ 31.826 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 18.818 }
			y={ 49.814 }
			fill="#9FABB4"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 26.43 }
			y={ 49.814 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 16.742 }
			y={ 52.581 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 0.692 }
			height={ 1.384 }
			x={ 28.504 }
			y={ 52.581 }
			fill="#58707F"
			rx={ 0.346 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 29.887 }
			y={ 52.581 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M25.833 40.694h.875a.878.878 0 0 0 .443-.07 1.02 1.02 0 0 0 .375-.285c.184-.279.276-.627.258-.98a1.513 1.513 0 0 0-.258-.912 1 1 0 0 0-.357-.267.866.866 0 0 0-.418-.07.995.995 0 0 0-.732.303c-.093.104-.167.23-.216.37-.05.14-.074.29-.07.441h-1.507c-.016-.348.04-.695.163-1.013.122-.317.307-.595.54-.811.503-.49 1.14-.748 1.793-.726.693-.045 1.376.207 1.923.71.23.245.41.549.528.888.116.34.167.705.147 1.07-.001.418-.111.825-.316 1.166a2.22 2.22 0 0 1-.876.861c.397.154.74.457.976.862.232.39.352.858.345 1.334a2.85 2.85 0 0 1-.18 1.131 2.46 2.46 0 0 1-.595.913c-.566.512-1.267.775-1.98.743-.662.026-1.311-.22-1.837-.692a2.208 2.208 0 0 1-.59-.875 2.583 2.583 0 0 1-.156-1.102h1.435c-.005.167.02.334.075.488.054.155.136.294.24.407.218.238.507.365.804.355a.954.954 0 0 0 .457-.08c.146-.063.279-.163.39-.291a1.31 1.31 0 0 0 .247-.45c.055-.169.078-.35.068-.53a1.462 1.462 0 0 0-.037-.58 1.307 1.307 0 0 0-.256-.498 1.053 1.053 0 0 0-.42-.307.91.91 0 0 0-.492-.05h-.875l.086-1.453ZM35.776 46.217H30.51v-1.233l2.497-3.277c.294-.396.554-.826.775-1.284.138-.296.217-.625.23-.962.008-.354-.088-.7-.273-.98a.916.916 0 0 0-.335-.292.771.771 0 0 0-.412-.08.81.81 0 0 0-.456.096.98.98 0 0 0-.361.343c-.19.353-.285.765-.273 1.183h-1.507a3.395 3.395 0 0 1 .156-1.165c.118-.371.3-.71.533-.997.249-.3.549-.536.88-.69a2.188 2.188 0 0 1 1.043-.205c.687-.047 1.362.226 1.88.76.228.262.407.578.523.927.116.35.168.725.151 1.1a3.222 3.222 0 0 1-.373 1.57c-.385.673-.812 1.31-1.277 1.909l-1.435 1.824h3.3v1.453ZM37.26 37.396a.878.878 0 0 1 .143-.524.538.538 0 0 1 .187-.155.453.453 0 0 1 .225-.047c.08-.006.159.01.233.044.073.035.14.09.194.158.1.148.15.335.142.524a.858.858 0 0 1-.142.524.536.536 0 0 1-.187.155.452.452 0 0 1-.225.047.465.465 0 0 1-.233-.044.55.55 0 0 1-.194-.158.858.858 0 0 1-.142-.524Zm.314 0c-.02.1-.02.204 0 .304.02.04.05.072.085.092.035.021.075.03.114.026a.149.149 0 0 0 .1-.027.194.194 0 0 0 .07-.091.578.578 0 0 0 .071-.304.687.687 0 0 0-.042-.253.207.207 0 0 0-.077-.094.16.16 0 0 0-.108-.025.148.148 0 0 0-.101.027.195.195 0 0 0-.07.092.678.678 0 0 0-.07.304l.028-.051ZM40.813 38.865c.007.156-.013.311-.06.456a1.155 1.155 0 0 1-.21.389c-.22.212-.498.32-.782.304a.867.867 0 0 1-.442-.085 1.028 1.028 0 0 1-.368-.304 1.37 1.37 0 0 1-.242-.45 1.545 1.545 0 0 1-.071-.53v-.641a1.53 1.53 0 0 1 .299-.98c.22-.229.503-.355.796-.355.293 0 .576.126.796.355.098.106.174.238.223.384.05.146.07.304.061.46h-.54a.864.864 0 0 0-.128-.506.533.533 0 0 0-.191-.136.463.463 0 0 0-.221-.033.442.442 0 0 0-.196.09.544.544 0 0 0-.145.18 1.2 1.2 0 0 0-.143.625v.642c-.012.224.044.445.157.625a.542.542 0 0 0 .182.176c.072.041.15.062.23.06a.402.402 0 0 0 .208-.032.473.473 0 0 0 .176-.136.765.765 0 0 0 .128-.49l.483-.068ZM37.26 43.165a.878.878 0 0 1 .143-.523.536.536 0 0 1 .187-.156.453.453 0 0 1 .225-.047c.08-.006.159.01.233.045.073.035.14.089.194.158.1.148.15.334.142.523a.858.858 0 0 1-.142.524.536.536 0 0 1-.187.156.455.455 0 0 1-.225.047.465.465 0 0 1-.233-.045.55.55 0 0 1-.194-.158.858.858 0 0 1-.142-.524Zm.314 0c-.02.1-.02.204 0 .304.02.04.05.072.085.093.035.02.075.03.114.026a.149.149 0 0 0 .1-.027.194.194 0 0 0 .07-.092.578.578 0 0 0 .071-.304.687.687 0 0 0-.042-.253.207.207 0 0 0-.077-.093.16.16 0 0 0-.108-.025.148.148 0 0 0-.101.027.195.195 0 0 0-.07.09.678.678 0 0 0-.07.305l.028-.05ZM40.46 44.414h-1.096v1.402h-.548v-3.378h1.89v.523h-1.342v.93h1.15l-.055.523ZM22.631 43.86a2.471 2.471 0 0 1-2.468 2.47H13.83a2.831 2.831 0 0 1 0-5.66h.078a2.694 2.694 0 0 1 4.98-.635 1.795 1.795 0 0 1 2.183 1.536 2.476 2.476 0 0 1 1.56 2.29Z"
		/>
	</svg>
);
